<script setup>
import { defineProps, reactive, ref } from 'vue';
import FileView from './FileViewer.vue'
import { ChatLineSquare } from '@element-plus/icons-vue'

const props = defineProps({
  dynamicForm: {
    type: Object,
    default: () => {},
  },
  tableData: {
    type: Object,
    default: () => {},
  },
  workDetail: {
    type: Object,
    default: () => {},
  },
  reviewdetails: {
    type: Array,
    default: () => [],
  },
})


const form = reactive({})

const fileVisible = ref(false)
const fileList = ref([])
const viewFile = (file) => {
  console.log('viewFile:',file)

  // 对作品进行处理，拿到文件的后缀名，判断是什么格式的文件
  // 如果是图片格式，直接打开图片
  // 如果是视频格式，直接打开视频
  // 如果是其他格式，使用浏览器默认打开方式 
  fileList.value = file.map(item => {
    const fileExtension = item.filename.split('.').pop().toLowerCase()
    switch (fileExtension) {
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
      case 'bmp':
        item.fileType = 'img'
        break
      case 'mp3':
      case 'wav':
      case 'aac':
      case 'm4a':
      case 'flac':
        item.fileType = 'audio'
        break
      case 'mp4':
      case 'avi':
      case 'mov':
      case 'wmv':
        item.fileType = 'video'
        break
      case 'pdf':
        item.fileType = 'pdf'
        break
      default:
        item.fileType = 'other'
        break
    }
    return {
      fileName: item.filename,
      fileId: item.file_id,
      fileType: item.fileType
    }
  })
  fileVisible.value = true
  // fileList.value = file
  console.log('file:',file)
  console.log('fileList.value:',fileList.value)
}

const downloadFile = (fileId) => {
  console.log('downloadFile:',fileId)
  // downloadFileApi({ file_id: fileId }).then(res => {
  //   if (res.data.code === 200) {
  //     window.open(res.data.data.url)
  //   }
  // })
}


const reviews = [
{
  id: 1,
  reviewer: "王教授",
  score: 9.2,
  excerpt: "该作品在交互设计上表现出色，用户体验流畅自然，视觉设计简洁大方。",
  fullReview: "该作品在交互设计上表现出色，用户体验流畅自然，视觉设计简洁大方。智能家居场景的切换逻辑清晰，用户学习成本低。建议在语音交互的容错处理上再做优化，增加更多方言支持。总体来说，这是一个成熟且具有商业潜力的设计方案。",
  time: "2024-01-16 10:30",
  rating: 5
},
{
  id: 2,
  reviewer: "李设计师",
  score: 8.5,
  excerpt: "创新性较强，将多种交互方式有机结合，但在细节处理上还有提升空间。",
  fullReview: "创新性较强，将多种交互方式有机结合，但在细节处理上还有提升空间。手势识别模块的灵敏度需要进一步优化，部分复杂手势的识别率有待提高。色彩搭配和谐，视觉层次分明，符合现代家居审美趋势。",
  time: "2024-01-16 11:15",
  rating: 4
},
{
  id: 3,
  reviewer: "张专家",
  score: 8.8,
  excerpt: "整体完成度高，功能齐全，技术实现方案合理，市场应用前景广阔。",
  fullReview: "整体完成度高，功能齐全，技术实现方案合理，市场应用前景广阔。能源可视化部分设计尤为出色，让用户能直观了解家庭能耗情况。建议增加更多预制场景模板，降低普通用户的配置难度。",
  time: "2024-01-16 13:45",
  rating: 4
},
{
  id: 4,
  reviewer: "刘研究员",
  score: 7.5,
  excerpt: "基础功能完善，但创新点不够突出，与其他同类产品区分度有限。",
  fullReview: "基础功能完善，但创新点不够突出，与其他同类产品区分度有限。安防监控部分的交互设计较为复杂，可以考虑简化操作流程。语音控制模块表现良好，响应速度快，识别准确率高。",
  time: "2024-01-16 14:20",
  rating: 3
},
{
  id: 5,
  reviewer: "陈总监",
  score: 9.0,
  excerpt: "商业价值高，用户研究深入，设计方案能真正解决用户痛点。",
  fullReview: "商业价值高，用户研究深入，设计方案能真正解决用户痛点。多用户权限管理设计合理，满足了家庭不同成员的需求。建议在隐私保护方面增加更多说明和设计考量。",
  time: "2024-01-16 15:10",
  rating: 5
},
{
  id: 6,
  reviewer: "赵工程师",
  score: 8.0,
  excerpt: "技术实现方案可行，系统架构设计合理，但部分功能的技术难度较高。",
  fullReview: "技术实现方案可行，系统架构设计合理，但部分功能的技术难度较高。建议提供更详细的技术实施方案，特别是多设备协同工作的部分。界面设计美观，符合现代扁平化设计趋势。",
  time: "2024-01-16 16:05",
  rating: 4
},
{
  id: 7,
  reviewer: "孙顾问",
  score: 8.7,
  excerpt: "用户体验考虑周到，无障碍设计做得很好，适合不同年龄段的用户使用。",
  fullReview: "用户体验考虑周到，无障碍设计做得很好，适合不同年龄段的用户使用。老年人模式的设计尤其贴心，字体放大、语音提示清晰。建议增加更多本地化服务集成，提升产品的实用性。",
  time: "2024-01-16 17:30",
  rating: 4
}
];


// 生成星级HTML
// function generateStars(rating) {
//   let stars = '';
//   for (let i = 1; i <= 5; i++) {
//     if (i <= rating) {
//       stars += '<el-icon><Star /></el-icon>';
//     } else {
//       stars += '<el-icon><Star /></el-icon>';
//     }
//   }
//   return `<div class="star-rating" v-html="${stars}"></div>`;
// }

// 根据分数获取颜色
const getScoreColor = (score)=> {
  if (score >= 90) return '#2ecc71'; // 绿色
  if (score >= 80) return '#3498db'; // 蓝色
  if (score >= 70) return '#f39c12'; // 橙色
  return '#e74c3c'; // 红色
}

</script>


<template>
  <div class="upload-container">
    <!-- label-width="280px" -->
    <el-form 
      :model="form" 
      ref="formRef"
      label-suffix="："
      label-width="auto"
      class="upload-form"
    >
      <!-- <div class="title">作品详情</div> -->
      <el-form-item label="作品名称" prop="work_name">
        {{ workDetail.work_name }}
      </el-form-item>
      <el-form-item label="作品描述" prop="work_description">
        {{ workDetail.work_description }}
      </el-form-item>
      <el-form-item label="参赛者姓名" prop="contestant_name">
        {{ workDetail.contestant_name }}
      </el-form-item>

      <template v-for="(table) in dynamicForm" :key="table.key">
        <el-form-item :label="table.name" :class="table.type === 'table' ? 'test' : ''">
          <template v-if="table.type === 'text' || table.type === 'select' ||
            table.type === 'textarea' || table.type === 'number' || 
            table.type === 'radio' || table.type === 'date'">
            {{ tableData[table.key] }}
          </template>
          <template v-if="table.type === 'file'">
            <el-button type="primary" link @click="viewFile(tableData[table.key])">
              查看
            </el-button>
            <!-- <div v-for="item in tableData[table.key]" :key="item.file_id">
              <div>
                <el-button type="primary" link @click="downloadFile(item.file_id)">
                  {{ item.filename }}
                </el-button>
              </div>
            </div> -->
            <!-- <el-upload
              class="avatar-uploader"
              :action="uploadUrl"
              :show-file-list="false"
              :accept="table.fileType"
              :on-success="handleAvatarSuccess"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload> -->
          </template>
          <template v-else-if="table.type === 'pic'">
            <el-upload
              class="avatar-uploader"
              :action="uploadUrl"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </template>
          <!-- <template v-else-if="table.type === 'date'">
            <el-date-picker
              v-model="table.value"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </template> -->
          
          <!-- <template v-if="table.type === 'radio'">
            <el-radio-group v-model="tableData[table.key]" size="small">
              <el-radio v-for="(item,index) in table.options" :key="index" :label="item" :value="item" />
            </el-radio-group>
          </template> -->
          <template v-if="table.type === 'checkbox'">
            {{ tableData[table.key].join(', ') }}
            <!-- <el-checkbox-group v-model="tableData[table.key]" size="small">
              <el-checkbox v-for="(item,index) in table.options" :key="index" :label="item" :value="item" />
            </el-checkbox-group> -->
          </template>
          <template v-if="table.type === 'table'">
            <el-table :data="tableData[table.key]" style="width: 100%" border stripe>
              <el-table-column type="index" :index="(index)=>{
                return table.subtables.rows[index].label
              }"  width="120"/>
              <el-table-column 
                v-for="(col, index) in table.subtables.columns" 
                :key="index"
                :prop="col.type"
                :label="col.name"
                min-width="120"
              >
                <template #default="scpoed">
                  <span v-if="col.type === 'text' || col.type === 'textarea' || col.type === 'select' ||
                    col.type === 'number' || col.type === 'radio' || col.type === 'date'
                    ">{{ scpoed.row[col.key] }}</span>
                  <template v-else-if="col.type === 'file'">
                    <el-button type="primary" link @click="viewFile(tableData[table.key])">
                      查看
                    </el-button>
                  </template>
                  <template v-else-if="col.type === 'checkbox'">
                    {{ scpoed.row[col.key].join(', ') }}
                  </template>
                  
                  <!-- <el-upload v-else-if="col.type === 'file'"
                    class="avatar-uploader"
                    :action="uploadUrl"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                  >
                    <el-button size="small" type="primary">点击上传</el-button>
                  </el-upload> -->
                  
                </template>
              </el-table-column>
              
            </el-table>

          </template>
          <!-- <template v-else>
            <el-input v-model="table.value" />
          </template> -->
        </el-form-item>
      </template>     
    </el-form>

    <div class="review-container" v-if="props.reviewdetails.length > 0">
      <h3 style="margin-bottom: 15px; display: flex; align-items: center;">
        <el-icon><ChatLineSquare /></el-icon>
        <span style="margin-left: 8px;">评审详情</span>
      </h3>
      <div class="review-list" v-for="(review, index) in props.reviewdetails" :key="index">
        <div class="review-item">
          <div class="review-header">
            <div class="reviewer-info">
              <div class="reviewer-avatar">{{review.reviewer_name?review.reviewer_name.charAt(0):'未知'}}</div>
              <div>
                <div class="reviewer-name">{{review.reviewer_name?review.reviewer_name:'未命名'}}</div>
                <div class="review-time">{{review.updated_at}}</div>
              </div>
            </div>
            
            <div class="review-score" :style="{color: getScoreColor(review.score)}">{{review.score.toFixed(1)}}</div>
          </div>
          <!-- {{generateStars(review.score)}} -->
          <div class="review-excerpt">{{review.comments}}</div>
          <!-- <div class="review-full">{{review.comments}}</div> -->
          <!-- <div class="review-footer">
            <span>点击查看完整评语</span>
            <span>评审ID: {{review.id.toString().padStart(3, '0')}}</span>
          </div> -->
        </div>
      </div>
    </div>
  </div>

  <el-dialog 
    title="文件预览"
    v-model="fileVisible"
    width="50%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="showClose"
  >
    <div style="padding: 20px;"> 
      <FileView :fileList="fileList" />
    </div>
  </el-dialog>
</template>



<style scoped>
.upload-container {
  /* padding: 20px; */
  /* background-color: #fff; */
}

.title {
  font-size: 18px;
  /* font-weight: bold; */
  margin-bottom: 30px;
  text-align: center;
}

.upload-form {
  /* max-width: 800px; */
  margin-bottom: 30px;
  margin-top: 20px;
  padding: 20px;
  /* padding-right: 50px; */
  /* background-color: #fff; */
  border-radius: 4px;
  /* background-color: #fff; */
  /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); */
}

.project-list {
  margin-top: 30px;
}


.file-input {
  width: 100%;
  padding: 1px 12px;
  border: 2px dashed #9ec8e4;
  border-radius: 8px;
  background: #f9f9f9;
  font-size: 16px;
  color: #7f8c8d;
  /* color: #165DFF; */
  cursor: pointer;
  transition: all 0.3s ease;
}
.file-input:hover {
  border-color: #165DFF;
  background: #e8f5ff;
}



/* 评审列表 */
.review-container {
  padding: 30px;
}

.review-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.review-item {
  background-color: #f8fafc;
  /* background-color: #fff; */
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  cursor: pointer;
  border-left: 4px solid #3498db;
  margin-bottom: 20px;
}

.review-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
}

.review-item.expanded {
  border-left-color: #2ecc71;
}

.review-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.reviewer-info {
  display: flex;
  align-items: center;
}

.reviewer-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #3498db;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  margin-right: 12px;
}

.reviewer-name {
  font-weight: 600;
  color: #2c3e50;
}

.review-time {
  font-size: 0.85rem;
  color: #95a5a6;
  margin-top: 2px;
}

.review-score {
  font-size: 1.8rem;
  font-weight: 700;
  color: #f39c12;
}

.review-excerpt {
  color: #555;
  line-height: 1.5;
  margin-top: 10px;
  display: -webkit-box;
  -webkit-box-orient: vertical;

  /* 固定高度的写法 */
  /* -webkit-line-clamp: 3;
  overflow-y: scroll; */

  /* 我觉得这里不需要固定高度吧，直接显示全部 */
  /* -webkit-line-clamp: 2; */
  /* overflow-y: hidden; */

}

.review-full {
  color: #555;
  line-height: 1.6;
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #eee;
  display: none;
}

.review-item.expanded .review-full {
  display: block;
}

.review-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  font-size: 0.9rem;
  color: #7f8c8d;
}
</style>